export const NOTIFICATION_CATALOG_VERSION = 1;
export const NOTIFICATION_EVENT_DEFINITIONS = [
    {
        defaultSeverity: "info",
        emailClassification: "operational",
        key: "approval.requested",
        producer: "content",
        safetyLockedSeverity: false,
    },
    {
        defaultSeverity: "info",
        emailClassification: "operational",
        key: "approval.approved",
        producer: "content",
        safetyLockedSeverity: false,
    },
    {
        defaultSeverity: "warning",
        emailClassification: "operational",
        key: "approval.rejected",
        producer: "content",
        safetyLockedSeverity: false,
    },
    {
        defaultSeverity: "warning",
        emailClassification: "operational",
        key: "verification.flagged",
        producer: "verifier",
        safetyLockedSeverity: false,
    },
    {
        defaultSeverity: "warning",
        emailClassification: "operational",
        key: "verification.failed",
        producer: "verifier",
        safetyLockedSeverity: false,
    },
    {
        defaultSeverity: "warning",
        emailClassification: "operational",
        key: "verification.unverified",
        producer: "verifier",
        safetyLockedSeverity: false,
    },
    {
        defaultSeverity: "warning",
        emailClassification: "operational",
        key: "verification.budget-threshold",
        producer: "verifier",
        safetyLockedSeverity: false,
    },
    {
        defaultSeverity: "warning",
        emailClassification: "operational",
        key: "compliance.notification",
        producer: "verifier",
        safetyLockedSeverity: false,
    },
    {
        defaultSeverity: "info",
        emailClassification: "operational",
        key: "publish.confirmed",
        producer: "content",
        safetyLockedSeverity: false,
    },
    {
        defaultSeverity: "info",
        emailClassification: "operational",
        key: "publish.approval-pending",
        producer: "content",
        safetyLockedSeverity: false,
    },
    {
        defaultSeverity: "warning",
        emailClassification: "operational",
        key: "approval.revoked",
        producer: "content",
        safetyLockedSeverity: false,
    },
    {
        defaultSeverity: "critical",
        emailClassification: "operational",
        key: "player.offline",
        producer: "devices",
        safetyLockedSeverity: true,
    },
    {
        defaultSeverity: "info",
        emailClassification: "operational",
        key: "player.recovered",
        producer: "devices",
        safetyLockedSeverity: false,
    },
    {
        defaultSeverity: "warning",
        emailClassification: "operational",
        key: "device.crash-loop",
        producer: "devices",
        safetyLockedSeverity: false,
    },
    {
        defaultSeverity: "warning",
        emailClassification: "operational",
        key: "device.cache-pressure",
        producer: "devices",
        safetyLockedSeverity: false,
    },
    {
        defaultSeverity: "critical",
        emailClassification: "operational",
        key: "emergency.triggered",
        producer: "scheduling",
        safetyLockedSeverity: true,
    },
    {
        defaultSeverity: "warning",
        emailClassification: "operational",
        key: "emergency.cleared",
        producer: "scheduling",
        safetyLockedSeverity: true,
    },
    {
        defaultSeverity: "info",
        emailClassification: "operational",
        key: "emergency.test-result",
        producer: "scheduling",
        safetyLockedSeverity: false,
    },
    {
        defaultSeverity: "info",
        emailClassification: "operational",
        key: "ota.succeeded",
        producer: "devices",
        safetyLockedSeverity: false,
    },
    {
        defaultSeverity: "warning",
        emailClassification: "operational",
        key: "ota.failed",
        producer: "devices",
        safetyLockedSeverity: false,
    },
    {
        defaultSeverity: "info",
        emailClassification: "transactional",
        key: "user.invited",
        producer: "tenancy",
        safetyLockedSeverity: false,
    },
    {
        defaultSeverity: "info",
        emailClassification: "operational",
        key: "user.activated",
        producer: "tenancy",
        safetyLockedSeverity: false,
    },
    {
        defaultSeverity: "info",
        emailClassification: "operational",
        key: "user.deactivated",
        producer: "tenancy",
        safetyLockedSeverity: false,
    },
    {
        defaultSeverity: "info",
        emailClassification: "operational",
        key: "user.role-changed",
        producer: "tenancy",
        safetyLockedSeverity: false,
    },
    {
        defaultSeverity: "info",
        emailClassification: "operational",
        key: "storage.quota-warning",
        producer: "tenancy",
        safetyLockedSeverity: false,
    },
    {
        defaultSeverity: "warning",
        emailClassification: "operational",
        key: "support.break-glass-access",
        producer: "security",
        safetyLockedSeverity: false,
    },
    {
        defaultSeverity: "warning",
        emailClassification: "operational",
        key: "tenant.approval-mode-downgraded",
        producer: "tenancy",
        safetyLockedSeverity: false,
    },
    {
        defaultSeverity: "warning",
        emailClassification: "operational",
        key: "notification.critical-coverage-gap",
        producer: "notifications",
        safetyLockedSeverity: false,
    },
    {
        defaultSeverity: "warning",
        emailClassification: "operational",
        key: "security.rate-limit-sustained",
        producer: "security",
        safetyLockedSeverity: false,
    },
    {
        defaultSeverity: "warning",
        emailClassification: "operational",
        key: "chat.destination-unhealthy",
        producer: "notifications",
        safetyLockedSeverity: false,
    },
    {
        defaultSeverity: "critical",
        emailClassification: "operational",
        key: "platform.incident",
        producer: "platform",
        safetyLockedSeverity: false,
    },
    {
        defaultSeverity: "info",
        emailClassification: "operational",
        key: "platform.maintenance-scheduled",
        producer: "platform",
        safetyLockedSeverity: false,
    },
    {
        defaultSeverity: "info",
        emailClassification: "operational",
        key: "audit.digest",
        producer: "audit",
        safetyLockedSeverity: false,
    },
];
const definitionsByKey = new Map(NOTIFICATION_EVENT_DEFINITIONS.map((definition) => [
    definition.key,
    definition,
]));
export function isNotificationEventType(value) {
    return definitionsByKey.has(value);
}
export function getNotificationEventDefinition(eventType) {
    const definition = definitionsByKey.get(eventType);
    if (!definition) {
        throw new Error("Notification event type is not registered");
    }
    return definition;
}
//# sourceMappingURL=notifications.js.map